import React from 'react';

import { Input } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { removeWhitespaces } from 'utils';
import { useRouter } from 'next/router';

interface CustomProps {
  value?: string;
  onChange?: (value: string) => void;
  options: OptionsProps;
}

interface OptionsProps {
  label: string;
  inputOptions: any;
}

export const FormItemConsumer: React.FC<CustomProps> = ({
  value = null,
  onChange,
  options,
}) => {
  const router = useRouter();
  const { query } = router;
  const isCampaign = query.campaign;

  const triggerChange = (changedValue) => {
    onChange?.(changedValue);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (options.inputOptions.type === 'email') {
      triggerChange(removeWhitespaces(e.target.value));
    } else {
      triggerChange(e.target.value);
    }
  };

  const formItemClassNames: string = classNames(
    'form-padding',
    'form-con',
    'custom-text-field',
    {
      'show-place-holder':
        value &&
        Object.keys(value).length !== 0 &&
        options?.inputOptions?.type === 'password',
    },
    {
      'campaign': isCampaign
    }

  );

  let inputWithType;

  switch (options?.inputOptions?.type) {
    case 'password':
      inputWithType = (
        <Input.Password  {...options.inputOptions} onChange={handleChange} />
      );
      break;
    case 'number':
      inputWithType = (
        <input
          {...options.inputOptions}
          type="number"
          placeholder=" "
          onChange={handleChange}
        />
      );
      break;
    default:
      inputWithType = (
        <Input
          value={value}
          {...options.inputOptions}
          placeholder=" "
          onChange={handleChange}
        />
      );
  }

  return (
    <div className={formItemClassNames} >
      {inputWithType}
      <label>
        <FormattedMessage id={options.label} />
      </label>
    </div>
  );
};
